module.exports = __webpack_public_path__ + "static/media/plebgraph_logo_2.2206404b.svg";